export const form = {
  formCopyLink: 'Скопіювати посилання',
  formLinkCopied: 'Посилання скопійовано!'
}
